import React, { useState, useEffect } from 'react'
import { get } from '../../../../../Model/Network/Config/Axios';
import { handleError } from '../../../../Common/fToast/ToastCallback';
import { KeyValue } from '../../../../Common/Components/KeyValue';

const IMSDetails = ({invoiceDeatails}) => {
    const [imsDetails, setIMSDetails] = useState(null);
    const {id} = invoiceDeatails;
    useEffect(() => {
        get(`vendor/invoicing/${id}/FetchImsDetails`, (e, r) => {
            if(r){
                setIMSDetails(r && r.invoices? r.invoices[0]: null);
            }else{
                handleError(e)
            }
        })
    }, [id])
  return (
    <div style={{marginTop:10}}>
        <h3 style={{marginBottom:10}}>IMS Details</h3>
        <KeyValue title="Buyer GSTIN" value={imsDetails && imsDetails.imsResponse && imsDetails.imsResponse.clientGstin} />
        <KeyValue title="InvoiceDate" value={imsDetails && imsDetails.invoiceDate} />
        <KeyValue title="Invoice Number" value={imsDetails && imsDetails.invoiceNumber} />
        <KeyValue title="Invoice Value" value={imsDetails && imsDetails.invoiceValue} />
        <KeyValue title="Vendor GSTIN" value={imsDetails && imsDetails.supplierGstin} />
        <KeyValue title="vendor Name" value={imsDetails && imsDetails.vendor && imsDetails.vendor.vendorName} />
        <KeyValue title="Tax Value" value={imsDetails && imsDetails.taxValue} />
        
    </div>
  )
}

export default IMSDetails